<template>
  <div class="index">
    <the-sidebar>
      <div class="sidebar-overview" v-show="sidebarStatus === 'NEARBY' || sidebarStatus === 'SUBJECT'">
        <!-- <div class="overview-header">
          <div class="overview-tab">
            <div class="tab-item"
                 :class="{ active: sidebarStatus === 'NEARBY' }"
                 @click="sidebarStatus = 'NEARBY'">附近大厅</div>
            <div class="tab-item"
                 :class="{ active: sidebarStatus === 'SUBJECT' }"
                 @click="sidebarStatus = 'SUBJECT'">全部专题</div>
          </div>
        </div> -->
        <el-scrollbar class="scrollbar">
          <div class="overview-body">
            <transition name="sidebar">
              <!-- 默认列表 -->
              <hall-list
              v-infinite-scroll="searchSiteList"
              v-loading="listLoadingSearch"
              infinite-scroll-immediate = false
              :infinite-scroll-disabled="listLoadingSearch || noMore"
              :data="currentDetailList"
              prefix="s"
              v-show="sidebarStatus === 'SUBJECT'"
              @selectHall="selectHall"
              @cancelBar="can"
              @cancel-bar="cancelHall"
              @show-nav="showNav"
              @active="active"></hall-list>
              <!-- <hall-list
                v-infinite-scroll="getHallList"
                v-loading="listLoading"
                infinite-scroll-immediate = false
                :infinite-scroll-disabled="listLoading || noMore"
                :data="handleHallList(hallList)"
                :itemCode="currentItem"
                v-show="sidebarStatus === 'NEARBY'"
                @selectHall="selectHall"
                @active="active"
                @cancel-bar="cancelHall"
                @show-nav="showNav"></hall-list> -->
            </transition>
            <transition name="sidebar">
              <subject-list v-show="sidebarStatus === 'SUBJECT'"
                            @selectSubject="selectSubject"></subject-list>
            </transition>
          </div>
        </el-scrollbar>
      </div>
      <div class="sidebar-detail" v-show="sidebarStatus === 'DETAIL'">
        <div class="detail-header">
          <span class="detail-back" @click="cancelSearch1('')"><i class="ri-arrow-left-s-line"></i>返回</span>
          <div class="detail-type">{{ detailHeaderName }}</div>
        </div>
        <div class="detail-body">
          <el-scrollbar class="scrollbar">
            <transition name="sidebar">
              <div v-if="currentDetailList.length">
                <!-- 大厅类型使用筛选组件 -->
                <hall-filter v-if="currentSubject && currentSubject.code === '1-1'" @changeFilter="filterSearch"></hall-filter>
                <!-- 列表组件除事项类型外，统一使用大厅列表组件 -->
                <el-collapse class="item-list"
                            v-infinite-scroll="searchHallList"
                            v-loading="listLoadingSearch"
                            infinite-scroll-immediate = false
                            :infinite-scroll-disabled="listLoadingSearch || noMoreSearch"
                             v-if="searchType && searchType === 'ITEM'">
                  <el-collapse-item v-for="(item, index) in currentDetailList"
                                    :key="index + item.code" @click.native="selectItem(item)">
                    <template slot="title">
                      <div class="item-title">
                        <div>{{ item.name }}</div>
                        <span>可办理大厅{{ item.hallCount }}个</span>
                      </div>
                    </template>
                    <!-- <hall-list :data="handleItemHallList(item.hallList, item.toggle)"
                               @selectHall="selectItemHall($event, item)"></hall-list> -->
                    <div class="view-more"
                         v-if="item.hallList.length > 3">
                      <span @click="item.toggle = !item.toggle">
                        <template v-if="item.toggle === false">展开<i class="ri-arrow-down-s-line"></i></template>
                        <template v-else>收起<i class="ri-arrow-up-s-line"></i></template>
                      </span>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <hall-list v-else
                  v-infinite-scroll="searchHallList"
                  v-loading="listLoadingSearch"
                  infinite-scroll-immediate = false
                  :infinite-scroll-disabled="listLoadingSearch || noMoreSearch"
                  :data="currentDetailList"
                  @selectHall="selectHall"
                  @show-nav="showNav"></hall-list>
              </div>
              <no-data v-else v-loading="listLoadingSearch">
                <div class="tip-title">您可以：</div>
                <div class="tip-info">1.在<span @click="cancelSearch('NEARBY')">附近大厅</span>查找结果；</div>
                <div class="tip-info">2.在<span @click="cancelSearch('SUBJECT')">全部专题</span>查找结果。</div>
              </no-data>
            </transition>
          </el-scrollbar>
        </div>
      </div>
      <transition name="sidebar">
        <the-nav v-show="showSidebarNav === true"
                 :data="navigationData"
                 @start="startTrip"
                 @clear="clearTrip"
                 @cancel-nav="cancelNav"></the-nav>
      </transition>
    </the-sidebar>
    <div class="map-container">
      <the-map :data="mapData"
               ref="map"
               @selectMarker="selectMarker"
               @showNav="showNav"></the-map>
      <transition name="sidebar">
        <the-hallbar ref="hallBar"
                     v-show="currentHall"
                     :data="currentHall"
                     :itemCode="currentItem"
                     @stopLoading="hallBarStopLoading"
                     @cancel-bar="cancelHall"></the-hallbar>
      </transition>
      <!-- <transition name="hall-panel">
            <hall-list ref="hallList"
                         :data="currentHall"
                         :itemCode="currentItem"
                         @cancel-bar="cancelHall"
                         @show-nav="showNav"></hall-list>
          </transition> -->
    </div>
  </div>
</template>

<script>
import hallMixins from "@/mixins/hallMixins";
import { mapGetters } from "vuex";
import Bus from "@/api/bus";
import { getSiteList, getProjectNameCount } from "@/api/hallApi";
// import Bus from '@/api/bus'
export default {
  name: "Index",
  mixins: [hallMixins],
  components: {
    TheSidebar: () => import("@comp/TheSidebar"),
    TheNav: () => import("@comp/TheNav"),
    TheHallbar: () => import("@comp/TheHallbar"),
    TheMap: () => import("@comp/TheMap"),
    SubjectList: () => import("@comp/SubjectList"),
    HallList: () => import("@comp/HallList"),
    HallFilter: () => import("@comp/HallFilter"),
    NoData: () => import("@comp/NoData")
  },
  data() {
    return {
      // 侧边栏当前状态：'NEARBY'：附近大厅；'SUBJECT'：全部专题；'DETAIL'：专题/搜索列表
      sidebarStatus: "SUBJECT",
      // 显示导航面板
      showSidebarNav: false,
      // 前序状态
      prevStatus: null,
      // 导航数据
      navigationData: {},
      yyjh: {
        code: "2-5",
        name: "医养结合机构",
        icon: "ri-hospital-fill",
        siteType: "D005",
        siteTypeName: "医养结合机构",
        sortOrder: "5"
      }
    };
  },
  computed: {
    ...mapGetters([
      "searchType",
      "searchValue",
      "geoLocation",
      "hallList",
      "currentArea"
    ]),
     lat() {
      return this.geoLocation[1];
    },
    lng() {
      return this.geoLocation[0];
    }
  },
  mounted() {
    const that = this;
    this.$store.dispatch("getAppraiseLabels");
    // debugger
    that.$store.commit('setSubject', {
        type: that.yyjh.siteType,
        value: null
      })
    that.mapData = that.handleHallList(that.hallList);
    // that.handleTounchListener();
    Bus.$on("val", data => {
      console.log("index", data);
      that.showpan = data;
    });
    // setTimeout(() => {
      that.searchSiteList(that.yyjh);
    // }, 1000);
  },
  methods: {
    searchSiteList(yyjh) {
      let that = this;
      console.log("yyjh", yyjh);
      if (that.listLoadingSearch) return;
      that.listLoadingSearch = true;
      console.log("that", that.currentSubject);
      var item = {
        code: "2-5",
        name: "医养结合机构",
        icon: "ri-hospital-fill",
        siteType: "D005",
        siteTypeName: "医养结合机构",
        sortOrder: "5"
      };
      // for (let i = 0; i < 3; i++) {
      //   setTimeout(() => {
      console.log("pageNumSearch", that.pageNumSearch);
      // if (that.geoLocation[0]) {
      getSiteList({
        page: that.pageNumSearch,
        size: that.pageSizeSearch,
        latitude:"36.813787", //that.lat, // 
        longitude:"118.054994",// that.lng, // 
        // regionCode: defaultCity.adcode,
        siteName: that.searchValue,
        regionCode: that.currentArea.code || defaultCity.adcode,
        siteType: item.siteType || ""
      })
        .then(res => {
          console.log("中国1", res);
          localStorage.setItem("res", res.data.records);
          let { state, rows: list, message } = res.data;
          if (state === 1) {
            // if (list.length == 0) {
            //   that.listLoadingSearch = false
            //   return that.noMoreSearch = true
            // }
            if (that.pageNumSearch == 1) {
              that.hallListSearch = list;
            } else {
              that.hallListSearch = that.hallListSearch.concat(list);
              // that.listLoadingSearch = true
            }

            var processedData = [];
            _.forEach(that.hallListSearch, item => {
              processedData.push({
                ...item,
                code: item.siteId,
                category: "2-1",
                name: item.siteName,
                type: item.siteTypeName,
                icon: "ri-syringe-fill",
                tag: item.labelNames
              });
            });
            that.currentDetailList = processedData;
            that.mapData = that.currentDetailList;

            that.listLoadingSearch = false;
            if (that.pageNumSearch > res.data.total) {
              that.listLoadingSearch = false;
              return (that.noMoreSearch = true);
            }
          } else {
            that.listLoadingSearch = false;
            Notification.error({
              title: "错误",
              message: message || "信息获取失败了"
            });
          }
        })
        .catch(err => {
          let { message } = err;
          that.listLoadingSearch = false;
          Notification.error({
            title: "错误",
            message: message || "信息获取失败了"
          });
        });
      that.pageNumSearch++;
    },
    cancelSearch1(){
      let that = this;
      console.log("0000")
      if (that.listLoadingSearch) return;
      that.listLoadingSearch = true;
      console.log("that", that.currentSubject);
      that.$store.commit('setSearchValue', {
          type: null,
          value: null
        })
      var item = {
        code: "2-5",
        name: "医养结合机构",
        icon: "ri-hospital-fill",
        siteType: "D005",
        siteTypeName: "医养结合机构",
        sortOrder: "5"
      };
      that.sidebarStatus="SUBJECT"
      that.searchSiteList(that.yyjh);
      // debugger
       getSiteList({
        page: that.pageNumSearch,
        size: that.pageSizeSearch,
        latitude:"36.813787", //that.lat, // 
        longitude:"118.054994",// that.lng, // 
        // regionCode: defaultCity.adcode,
        // siteName: that.searchValue,
        regionCode: that.currentArea.code || defaultCity.adcode,
        siteType: item.siteType || ""
      })
        .then(res => {
          console.log("中国222", res);
          localStorage.setItem("res", res.data.records);
          let { state, rows: list, message } = res.data;
          if (state === 1) {
            // if (list.length == 0) {
            //   that.listLoadingSearch = false
            //   return that.noMoreSearch = true
            // }
            if (that.pageNumSearch == 1) {
              that.hallListSearch = list;
            } else {
              that.hallListSearch = that.hallListSearch.concat(list);
              // that.listLoadingSearch = true
            }

            var processedData = [];
            _.forEach(that.hallListSearch, item => {
              processedData.push({
                ...item,
                code: item.siteId,
                category: "2-1",
                name: item.siteName,
                type: item.siteTypeName,
                icon: "ri-syringe-fill",
                tag: item.labelNames
              });
            });
            that.currentDetailList = processedData;
            that.mapData = that.currentDetailList;

            that.listLoadingSearch = false;
            if (that.pageNumSearch > res.data.total) {
              that.listLoadingSearch = false;
              return (that.noMoreSearch = true);
            }
          } else {
            that.listLoadingSearch = false;
            Notification.error({
              title: "错误",
              message: message || "信息获取失败了"
            });
          }
        })
        .catch(err => {
          let { message } = err;
          that.listLoadingSearch = false;
          Notification.error({
            title: "错误",
            message: message || "信息获取失败了"
          });
        });
      that.pageNumSearch++;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.index {
  position: relative;
  width: 100%;
  height: 100%;
  ::v-deep .the-sidebar {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
  .map-container {
    position: relative;
    z-index: 3;
    margin-left: $sidebarWidth;
    height: 100%;
  }
}
.sidebar-overview {
  position: relative;
  width: 100%;
  height: 100%;
  .overview-header {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    width: 100%;
    padding: $paddingVertical $paddingHorizontal;
    background-color: #fff;
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    // backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(255, 255, 255, 0.72);
  }
  .overview-body {
    position: relative;
    width: 100%;
    height: 100%;
    // padding-top: 72px;
  }
  .overview-tab {
    height: 40px;
    padding: 4px;
    background: #f5f7fa;
    border-radius: 8px;
    .tab-item {
      float: left;
      width: 50%;
      height: 32px;
      line-height: 32px;
      color: #8c9ab3;
      text-align: center;
      border-radius: 6px;
      cursor: pointer;
      transition: $transitionTime;
      &:hover {
        color: $colorTextPrimary;
      }
      &.active {
        color: $colorTextPrimary;
        background: #fff;
        box-shadow: 1px 1px 3px 0 #dde4ef;
      }
    }
  }
}
.sidebar-detail {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 48px;
  .detail-header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 48px;
    padding: 0 $paddingHorizontal;
    line-height: 48px;
    background: #f5f8fc;
  }
  .detail-back {
    position: relative;
    float: left;
    padding-right: 8px;
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    transition: $transitionTime;
    i {
      font-size: 16px;
      vertical-align: -3px;
    }
    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      height: 12px;
      margin: auto 0;
      background-color: #999;
    }
    &:hover {
      color: $colorPrimary;
    }
  }
  .detail-type {
    margin-left: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .detail-body {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
.tip-title {
  padding-top: 24px;
  margin-bottom: 8px;
  font-size: 16px;
}
.tip-info {
  span {
    margin: 0 4px;
    color: $colorPrimary;
    cursor: pointer;
    text-decoration: underline;
  }
}
.view-more {
  padding: 8px 0;
  text-align: center;
  span {
    cursor: pointer;
    &:hover {
      color: $colorPrimary;
    }
  }
  i {
    width: 18px;
    height: 18px;
    margin-left: 4px;
    text-align: center;
    line-height: 18px;
    color: $colorPrimary;
    background: $colorPrimaryLighten;
    vertical-align: -3px;
    border-radius: 50%;
  }
}
</style>
